export enum ApiStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  COMPLETE = 'complete',

  FAILED = 'failed',
  FORBIDDEN = 'forbidden', // subtype of failed, when 403 status code is returned
}

// Auth Endpoints
const authControllerBaseAPI = '/auth';

export const forgotPasswordAPI = `${authControllerBaseAPI}/password/forgot`;
export const resetPasswordAPI = `${authControllerBaseAPI}/password/reset`;
export const userProfileAPI = `${authControllerBaseAPI}/profile`;

// Positions Endpoints
const posiitonsControllerBaseAPI = '/positions';

export const getPositionsAPI = `${posiitonsControllerBaseAPI}/`;

// Candidates Endpoints
const candidatesControllerBaseAPI = '/candidates';

export const getCandidateDetailsAPI = (id: string) =>
  `${candidatesControllerBaseAPI}/${id}`;
export const postCandidateFeedbackAPI = (id: string) =>
  `${candidatesControllerBaseAPI}/${id}/feedback`;

export const cancelCandidateInterviewAPI = (id: string) =>
  `${candidatesControllerBaseAPI}/${id}/interview/cancel`;

export const rescheduleCandidateInterviewAPI = (id: string) =>
  `${candidatesControllerBaseAPI}/${id}/interview/reschedule`;

export const postInterviewFeedbackAPI = (id: string) =>
  `${candidatesControllerBaseAPI}/${id}/interview/feedback`;

export const getCandidateSummaryViewAPI = (id: string) =>
  `${candidatesControllerBaseAPI}/summary-view/${id}`;

export const getCandidateVideoInterviewUrl = () =>
  `${candidatesControllerBaseAPI}/video-interview/url`;

export const sendCandidateQuestionAPI = (id: string) =>
  `${candidatesControllerBaseAPI}/${id}/questions`;

// User Notification Settings Endpoints
const userNotificationSettingsBaseAPI = '/user-notification-settings';

export const unsubscribeFromNotificationsAPI = () =>
  `${userNotificationSettingsBaseAPI}/unsubscribe`;

// Teams Endpoints
export const resubscribeToNotificationsAPI = () =>
  `${userNotificationSettingsBaseAPI}/resubscribe`;

export const fetchNotificationStatusAPI = (email: string) =>
  `${userNotificationSettingsBaseAPI}/status?email=${encodeURIComponent(email)}`;

const teamsBaseApi = '/teams';

export const getTeamsAPI = () => `${teamsBaseApi}`;

export const getTeamMemberAPI = (teamId: string, memberId: string) =>
  `${teamsBaseApi}/${teamId}/members/${memberId}`;

export const getAccountPermissionsAPI = () => `${teamsBaseApi}/permissions`;

export const getAccountImpersonationAPI = () => `${teamsBaseApi}/impersonation`;
